export const ISSUE_STATUSES = [
  { id: 'unresolved', label: 'Unresolved', description: 'The issue remains unresolved and requires attention.', color: '#f59e0b' },
  { id: 'neutral', label: 'Neutral', description: 'The issue status is neither resolved nor unresolved.', color: '#6b7280' },
  { id: 'resolved', label: 'Resolved', description: 'The issue has been successfully addressed and is no longer active.', color: '#ff9800' },
];